import { Label } from "expano-components";
import { MainList, Main } from "components";

import { ReactComponent as ShopIcon } from "icons/shop.svg";

import { sort, filters } from "./const/data";

const OffersEmptyList = () => (
  <Main
    page={{
      name: "Oferty bez produktu",
      icon: <ShopIcon />,
      breadcrumbs: [
        {
          name: "Oferty bez produktu",
        },
      ],
    }}
  >
    <MainList
      query_key="offers_empty"
      api_path="/offers"
      api_ransack="q[channel_product_id_blank]=1"
      sort_column="id"
      sort_direction="desc"
      context="ui_index"
      sort={sort}
      filters={filters}
      renderItem={({
        title,
        external_id,
        url,
        sku,
        channel: { shop, platform },
      }) => (
        <>
          <td>{title}</td>
          <td>
            {external_id ? (
              <a target="_blank" rel="noopener noreferrer" className="text-link" href={url}>
                {external_id}
              </a>
            ) : (
              ""
            )}
          </td>
          <td>{sku}</td>
          <td>
            <Label
              type="double"
              left={{
                text: shop?.label_text,
                color: `#${shop?.label_color}`,
              }}
              right={{
                text: platform?.label_text,
                color: `#${platform?.label_color}`,
              }}
            />
          </td>
        </>
      )}
    />
  </Main>
);

export default OffersEmptyList;
